import { Space, Tag, Typography } from 'antd'
import type { ColumnsType } from 'antd/es/table'

import type { CatalogImage, ImageAction } from './api'
import { ImageActions } from './components/ImageActions'

export function imageColumns(
  canWrite: boolean,
  edit: (image: CatalogImage) => void,
  act: (image: CatalogImage, action: ImageAction) => void,
): ColumnsType<CatalogImage> {
  return [
    {
      title: 'Image',
      key: 'image',
      render: (_, i) => (
        <>
          <Typography.Text strong>
            {i.distribution} {i.name}
          </Typography.Text>
          <br />
          <Typography.Text type="secondary">{i.slug}</Typography.Text>
        </>
      ),
    },
    {
      title: 'Source',
      key: 'source',
      render: (_, i) =>
        i.source.kind === 'IMAGE' ? 'Prepared clone' : 'HTTP download',
    },
    {
      title: 'Visibility',
      key: 'state',
      render: (_, i) => (
        <Space wrap>
          <Tag
            color={
              ['DEFAULT', 'PUBLISHED'].includes(i.state.status)
                ? 'green'
                : undefined
            }
          >
            {i.state.status === 'DEFAULT'
              ? 'Published'
              : {
                  PUBLISHED: 'Published',
                  HIDDEN: 'Hidden',
                  REMOVED: 'Removed',
                }[i.state.status]}
          </Tag>
          {i.state.status === 'DEFAULT' && <Tag color="blue">Default</Tag>}
        </Space>
      ),
    },
    {
      title: 'Preparation',
      key: 'preparation',
      render: (_, i) => {
        if (i.source.kind === 'HTTP') return 'Not required'
        if (!i.preparations.length) return 'Awaiting observations'
        const errors = i.preparations.filter(
          (p) => p.error || p.phase === 'FAILED',
        ).length
        if (errors)
          return (
            <Typography.Text type="danger">
              Error on {errors} {errors === 1 ? 'cluster' : 'clusters'}
            </Typography.Text>
          )
        const ready = i.preparations.filter((p) => p.phase === 'READY').length
        return `${ready === i.preparations.length ? 'Ready' : 'Preparing'} ${ready}/${i.preparations.length} observed`
      },
    },
    {
      title: 'Actions',
      key: 'actions',
      width: 96,
      fixed: 'right',
      render: (_, i) =>
        !canWrite || i.state.status === 'REMOVED' ? null : (
          <ImageActions image={i} edit={edit} act={act} />
        ),
    },
  ]
}
